import React, { FunctionComponent } from "react";

import { AlignItems, FlexDirection, Icon, IconSize, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils/bemClassNames";
import { IconCode } from "@multiweb/types/contracts";

export type NoNotificationItemsComponentProps = {
    text: string | undefined;
};

const classNames = bemClassNames("no-notification-items-component");

export const NoNotificationItemsComponent: FunctionComponent<NoNotificationItemsComponentProps> = ({ text = "" }) => (
    <div className={classNames()}>
        <Layout
            spacingSize={SpacingSize.l}
            alignItems={AlignItems.center}
            flexDirection={FlexDirection.column}
        >
            <Layout spacingSize={SpacingSize.s}>
                <Icon
                    iconCode={IconCode.docArchiveEmpty}
                    size={IconSize.large}
                />
            </Layout>
            {text && (
                <div className={classNames("text")}>
                    {text}
                </div>
            )}
        </Layout>
    </div>
);
